import { OrderFormat } from "@ancon/wildcat-types";
import clsx from "clsx";

import OutletCardOutletStatus from "./OutletCardOutletStatus";
import styles from "./OutletCardOutletInfoSummary.module.scss";
import HeadingText from "../support/HeadingText";
import BodyText from "../support/BodyText";
import OrderTypeIcon from "../support/OrderTypeIcon";

interface OutletCardOutletInfoSummaryProps {
  outletName: string;
  showOutletStatus?: boolean;
  isOutletOpen?: boolean;
  className?: string;
}

export default function OutletCardOutletInfoSummary({
  outletName,
  showOutletStatus = false,
  isOutletOpen = false,
  className,
}: OutletCardOutletInfoSummaryProps) {
  const showOutletBanner = false;
  const isWhiteLabeled = true;

  // Random outlet address label
  const outletAddresses = [
    "Masthamnsgatan 1, Göteborg",
    "Kyrkogatan 64, Göteborg",
    "Garnisonsgatan 23, Helsingborg",
    "Nedre Långvinkelsgatan 7, Helsingborg",
  ];
  const outletAddress =
    outletAddresses[Math.floor(Math.random() * outletAddresses.length)];

  const orderFormats = [
    OrderFormat.EatIn,
    OrderFormat.TakeAway,
    OrderFormat.Delivery,
    OrderFormat.TableOrder,
  ];

  const hasDeliveries = Math.random() > 0.5;
  const outletDistance = Math.random() * 20;
  const outletDistanceLabel = `${outletDistance.toFixed(1)} ${
    outletDistance > 1 ? "km" : "m"
  }`;

  const cuisines = [
    "Pizza",
    "Burgers",
    "Sushi",
    "Indian",
    "Thai",
    "Chinese",
    "Italian",
  ];
  const cuisinesText = cuisines
    .sort(() => Math.random() - 0.5)
    .slice(0, 2)
    .join(", ");

  function getFormattedDeliveryFee() {
    if (hasDeliveries) {
      return "40 kr";
    }

    return "Free Delivery";
  }

  return (
    <div className={clsx(styles.container, className)}>
      {showOutletStatus && !showOutletBanner && (
        <OutletCardOutletStatus isOutletOpen={isOutletOpen} />
      )}
      <HeadingText
        as="h3"
        title={outletName}
        color={isWhiteLabeled ? "heading-1" : "heading-0"}
      >
        {outletName}
      </HeadingText>
      <BodyText
        className={styles.addressText}
        title={outletAddress}
        color={isWhiteLabeled ? "body-1" : "body-0"}
      >
        {outletAddress}
      </BodyText>
      {cuisinesText && (
        <BodyText className={styles.cuisineText} title={cuisinesText}>
          {cuisinesText}
        </BodyText>
      )}
      <div className={styles.footer}>
        <div className={styles.footerLeft}>
          <BodyText>{outletDistanceLabel}</BodyText>
          {hasDeliveries && (
            <BodyText>
              &nbsp; &middot; &nbsp;
              {getFormattedDeliveryFee()}
            </BodyText>
          )}
        </div>
        <div>
          {orderFormats.map(orderFormat => (
            <OrderTypeIcon
              key={orderFormat}
              orderFormat={orderFormat}
              className={clsx({
                [styles.availableOrderType]:
                  isWhiteLabeled && orderFormats.includes(orderFormat),
              })}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
